<ng-content></ng-content>

<ng-template>
  <h1 class="text-center" matDialogTitle>원하는 이미지를 선택하세요</h1>

  <mat-dialog-content>
    <div *ngFor="let img of images" class="p-2" fxFlex.lg="25%" fxFlex="25%" fxFlex.sm="80%">
      <mat-card>
        <img class="clickable" mat-card-image [src]=img.downloadURL (click)="onSubmit(img.downloadURL)">
      </mat-card>
    </div>
  </mat-dialog-content>

  <div class="photo-dropzone w-100 text-center p-5 mt-3" appFileDrop (fileOver)="onFileOver($event)" (fileDrop)="onFileDrop($event)">
    <h2 class="color-gray">이미지를 드래그 해주세요. 권장 사이즈는 600x400입니다</h2>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-photo-choice-button/syllabus-photo-choice-button.component.html